import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from '@shared/services/login';
import { rx, Observable } from '@shared/rx';

@Injectable()
export class AuthGuard implements CanActivate {
  public constructor(
    private loginService: LoginService,
    private router: Router,
  ) {}

  public canActivate(): Observable<boolean> {
    return this.loginService.isLoggedIn.pipe(
      rx.map((event) => {
        if (!event) {
          this.router.navigate(['login']);
        }

        return event;
      }),
    );
  }
}
